import billing from '../locales/en/billing.json';
import common from '../locales/en/common.json';
import dashboard from '../locales/en/dashboard.json';
import documents from '../locales/en/documents.json';
import help from '../locales/en/help.json';
import location from '../locales/en/location.json';
import projects from '../locales/en/projects.json';
import reports from '../locales/en/reports.json';
import savings from '../locales/en/savings.json';
import services from '../locales/en/services.json';
import subsidiary from '../locales/en/subsidiary.json';
import tickets from '../locales/en/tickets.json';
import vendors from '../locales/en/vendors.json';
import yourTeam from '../locales/en/your-team.json';

export const resources = {
  en: {
    common,
    dashboard,
    billing,
    documents,
    help,
    location,
    reports,
    savings,
    services,
    subsidiary,
    tickets,
    vendors,
    projects,
    'your-team': yourTeam,
  },
};

export const supportedLngs = Object.keys(resources);

export const fallbackLng = supportedLngs[0];

export const ns = Object.keys(resources[fallbackLng as keyof typeof resources]);

export type Resource = typeof resources.en;

export type Namespace = keyof Resource;
